<template>
  <div class="co-lead-question">
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="YES_NO_OPTIONS"
      :displayType="displayflex"
      size="sm"
      rules="required"
    >
      <template v-slot:label>Is this a Co-Lead claim? <span class="text-danger">*</span></template>

      <template v-slot:first>
        <b-form-select-option :value="undefined" disabled
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>

    <div class="co-lead-question__info">
      We accept Co-Lead cash calls whether or not all UMRs are submitted to LimeIQ, including non-Lloyd's.
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { YES_NO_OPTIONS } from '@constants'
import { BaseSelect } from '@components/base'

export default defineComponent({
  name: 'CashCallColeadQuestion',
  components: {
    BaseSelect
  },
  props: {
    value: Boolean
  },
  emits: ['input'],
  setup(props, { emit }) {
    const displayflex = "dropdownWidth-sm"

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      YES_NO_OPTIONS,
      modelValue,
      displayflex
    }
  }
})
</script>

<style scoped>
.co-lead-question__info {
  background-color: #f8f9fa;
  border-left: 3px solid #1c4a50;
  border-radius: 0 6px 6px 0;
  padding: 12px 14px;
  margin-top: 4px;
  font-size: 0.88rem;
  color: #495057;
  line-height: 1.5;
}
</style>
